import { Component, HostListener, inject } from '@angular/core';
import { CommonModule, DatePipe, formatDate } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatInputModule } from '@angular/material/input';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { ToastrService } from 'ngx-toastr';
import { PaginationHelper } from '../../shared/services/pagination.service';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { PurchaseOrderService } from '../../features/purchase-order/services/purchase-order.service';
import { PermissionService } from '../../shared/services/permission.service';
import { ModuleIds } from '../../shared/permission-constants/permission-const';

@Component({
  selector: 'app-purchase-order',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatInputModule,
    AgGridAngular,
    // PermissionDirective,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './purchase-order.component.html',
  styleUrl: './purchase-order.component.scss'
})
export class PurchaseOrderComponent {
  public viewPortSize: boolean = false;
  public rowData: any[] | null = null;
  public loading: boolean = true;
  readonly dialog = inject(MatDialog);
  private searchSubject = new Subject<string>();
  // Permission = Permission;
  projectId: number;
  filter: any;
  startDate: any;
  endDate: any;
  dateRangeForm: FormGroup;
  columnDefs: ({ headerName: string; field: string; flex: number; cellRenderer?: undefined; floatingFilter?: undefined; filter?: undefined; } | { headerName: string; field: string; flex: number; cellRenderer: (params: any) => HTMLDivElement; floatingFilter: boolean; filter: boolean; })[];
  dateFilter = (date: Date | null): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Remove time component
    return date ? date <= today : false;
  };
  page = 0;
  pageSize = 10;
  totalPages = 1;
  pageSizeOptions = [5, 10, 20, 50, 100];
  search: any;

  canAddPO$ = this.permissionService.hasPermission(
    ModuleIds.PurchaseOrder,
    'Create'
  );
  canEditPO$ = this.permissionService.hasPermission(
    ModuleIds.VendorInvoice,
    'Edit'
  );

  canEditPO: boolean = false;

  constructor(
    private router: Router,
    private purchaseOrderService: PurchaseOrderService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private permissionService: PermissionService
  ) { }

  ngOnInit() {
    const navigation = history.state;
    this.projectId = navigation.projectID || null;
    this.fetchAllPurchaseOrder();
    const startDate = new Date();
    const endDate = new Date();
    const formatDate = (date: Date) => {
      return date.toLocaleDateString('en-CA');
    };
    
    this.filter = {
        startDate: formatDate(startDate),
        endDate: formatDate(endDate)
    }

    this.dateRangeForm = this.fb.group({
      startDate: [''],
      endDate: ['']
    });

    this.canEditPO$.subscribe((canEditPO) => {
      this.canEditPO = canEditPO;
    })

    
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.search = searchTerm;
        this.fetchAllPurchaseOrder();
      });

    this.checkViewportSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {

    this.columnDefs = [
      { headerName: 'Date', field: 'date', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Purchase order#', field: 'purchaseOrder', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Reference#', field: 'reference', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Vendor Name', field: 'vendorName', flex: this.viewPortSize ? 1 : 0 },
      {
        headerName: 'Status',
        field: 'status',
        flex: this.viewPortSize ? 1 : 0,
        floatingFilter: false,
        filter: false,
        cellRenderer: (params: any) => {
          const status = params.value || '';
          const div = document.createElement('div');
          div.style.fontWeight = 'bold';
      
          switch (status) {
            case 'DRAFT':
              div.style.color = 'gray';
              break;
            case 'OPEN':
              div.style.color = 'orange';
              break;
            case 'Approved':
              div.style.color = 'blue';
              break;
            case 'ISSUED':
              div.style.color = 'green';
              break;
            case 'CANCELLED':
              div.style.color = 'red';
              break;
            default:
              div.style.color = 'black';
          }
      
          div.textContent = status;
          return div;
        }
      },      
      // { headerName: 'Billed Status', field: 'billedStatus', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Amount', field: 'amount', flex: this.viewPortSize ? 1 : 0 },
      // { headerName: 'Expected Delivery', field: 'expectedDelivery', flex: this.viewPortSize ? 1 : 0 },
      {
        headerName: 'Actions',
        field: 'action',
        flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any) => {
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          container.style.gap = '20px';

          const editIcon = document.createElement('img');
          editIcon.src = 'assets/images/icons/icon-edit.svg';
          editIcon.style.cursor = 'pointer';
          editIcon.setAttribute('data-action', 'edit');

          // const deleteIcon = document.createElement('img');
          // deleteIcon.src = 'assets/images/icons/icon-delete.svg';
          // deleteIcon.style.cursor = 'pointer';
          // deleteIcon.setAttribute('data-action', 'delete');
          if(params.data?.status==='DRAFT'||params.data?.status==='OPEN'){
            if(this.canEditPO){
              container.appendChild(editIcon);
            }
            // container.appendChild(deleteIcon);
          }
          return container;
        },
        floatingFilter: false,
        filter: false,
      },
    ];
  }

  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10, 25, 50];
  public themeClass: string = 'ag-theme-quartz';


  onCellClicked(params: any) {
    const purchaseOrderId = params.data?.id;
    const billedStatus = params.data?.billedStatus;
    const purchaseOrderStatus = params.data?.purchaseOrderStatus;
    console.log("purchaseorderid-purchaseOrderStatus", purchaseOrderStatus);

    if (
      params.column.colId === 'action' &&
      params.event.target.dataset.action
    ) {
      let action = params.event.target.dataset.action;
      if (action === 'delete') {
        this.onConfirmDelete(purchaseOrderId);
      }
      else if (action === 'edit') {
        this.navigateToEdit(purchaseOrderId, purchaseOrderStatus, billedStatus)
      }
    }
    else {
      const id = params.data?.id;
      this.router.navigate([`purchase-order/purchase-order-details`], {
        queryParams: { id: id },
      });
      // this.router.navigate([`purchase-order/purchase-order-details/${id}`]);
    }
  }
  onConfirmDelete(id: number): void {
    const dialogRef = this.dialog.open(ConfirmDialog);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.onDelete(+id);
      }
    });
  }

  onDelete(purchaseOrderId: any) {
    const id = +purchaseOrderId;
    // this.purchaseOrderService.removePurchaseOrder(id).subscribe({
    //   next: () => {
    //     this.fetchAllPurchaseOrder();
    //     this.toastr.success('Deleted successfully.');
    //   },
    //   error: (error) => {
    //     this.toastr.error(error.message || 'Failed to delete.');
    //   },
    // });
  }

  navigateToEdit(id: string, status: string, billedStatus: string) {
    if (!id) {
      this.toastr.error('Purchase Order ID is missing. Unable to navigate to edit.');
      return;
    }

    // Check if both conditions are true
    if (status === 'CLOSED' && billedStatus === 'BILLED') {
      this.toastr.error('Cannot edit. Purchase order is closed and has already been billed.');
      return;
    }

    // Navigate to edit page
    this.router.navigate([`/purchase-order/purchase-order-edit/${id}`]);
  }


  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }
  navigateTo(route: string) {
    this.router.navigate([route]);
  }


  // fetchAllPurchaseOrder(search: string = '') {
    // this.loading = true;
    // this.purchaseOrderService.fetchAllPurchaseOrder(search, false, Number(this.projectId), this.startDate, this.endDate).subscribe({
    //   next: (orders) => {
    //     this.rowData = orders.map((order: any) => {
    //       return {
    //         id: order?.id,
    //         date: this.datePipe.transform(order?.billDate, 'dd/MM/yyyy', '+0000') || '--',
    //         purchaseOrder: order?.purchaseOrderNo,
    //         workorder: order?.workorderData?.workOrderNo,
    //         reference: order?.reference,
    //         vendorName: order?.vendor?.displayName,
    //         status: order?.purchaseStatus,
    //         billedStatus: order?.billStatus,
    //         amount: order?.totalPrice.toFixed(2),
    //         expectedDelivery: this.datePipe.transform(order?.dueDate, 'dd/MM/YYYY') || '--',
    //         purchaseOrderStatus: order?.purchaseStatus

    //       }
    //     });
    //   }
    // })

  // }


  onDateChange(event: any, type: string) {
    const formattedDate = this.datePipe.transform(event.value, 'yyyy-MM-dd');
    if (type === 'start') {
      this.startDate = formattedDate;
    } else if (type === 'end') {
      this.endDate = formattedDate;
    }
    if (this.startDate != null && this.endDate != null) {
      // this.filter = { startDate: this.startDate, endDate: this.endDate };
      this.fetchAllPurchaseOrder();
    }
  }

  fetchAllPurchaseOrder( pageSize: number = 10): void {
    this.loading = true;
    if (pageSize) {
      this.pageSize = pageSize;
    }
    // const filter = {
    //   quoteStatus : this.parentQuoteStatus
    // }
    const skip = this.page * this.pageSize;
    const input = {
      search: this.search,
      limit: this.pageSize,
      // filter,
      // advancedSearch: this.advancedSearch,
      startDate:this.startDate,
      endDate: this.endDate,
      skip,
    }
      this.purchaseOrderService.fetchAllPurchaseOrder(input).subscribe({
        next: (orders) => {
          console.log("orders", orders);
          
          this.rowData = (orders.purchaseOrders).map((order: any) => {
            const items = orders?.items || orders || [];
            this.totalPages = Math.ceil((orders?.total || items.length) / this.pageSize);
            return {
              id: order?.id,
              date: this.datePipe.transform(order?.billDate, 'dd/MM/yyyy', '+0000') || '--',
              purchaseOrder: order?.purchaseOrderNo,
              reference: order?.reference,
              vendorName: order?.vendor?.vendorName,
              status: order?.purchaseStatus,
              // billedStatus: order?.bills?.billStatus,
              amount: order?.totalAmount.toFixed(2),
              expectedDelivery: this.datePipe.transform(order?.dueDate, 'dd/MM/YYYY') || '--',
              purchaseOrderStatus: order?.purchaseStatus
            }
          });
        },

      error: (err) => {
        this.toastr.error('Failed to load purchase orders.',err);        
        this.loading = false;
      },
    })
  }

  onClear() {
    this.startDate = null;
    this.endDate = null;
    // this.selectedCustomerId = null;
    this.dateRangeForm.reset();
    this.fetchAllPurchaseOrder();
  }

  onPageSizeChange(event: Event): void {
    const newSize = Number((event.target as HTMLSelectElement).value);
    console.log('New Page Size:', newSize);
    this.pageSize = newSize; // ✅ Correctly update pageSize
    this.page = 0; // ✅ Reset to first page
    this.fetchAllPurchaseOrder(this.pageSize); // ✅ Use new pageSize
  }

  nextPage() {
    if (this.page + 1 < this.totalPages) {
      this.page++;
      this.fetchAllPurchaseOrder(this.pageSize);
    }
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.fetchAllPurchaseOrder(this.pageSize);
    }
  }
}
